<!--
SDEV-FILE
Copyright (c) 2026 SDEV. All rights reserved.
Workspace: clientside
File: DiscoveryView.vue
Created: 2026-03-13T17:32:48.252Z
-->

<template>

    <BasePage :header="header" :tabs="tabs" v-model:activeTab="activeTab">

        <!-- Discovered Sources -->
        <template #tab-sources>
            <slot name="sources" :rows="rows" :loading="loading" :select="selectRow" />
        </template>

        <!-- Start Discovery -->
        <template #tab-discover>
            <slot name="discover" :model="createModel" :discover="discover" />
        </template>

        <!-- Schema Inspection -->
        <template #tab-inspect>
            <slot name="inspect" :selected="selected" :model="editModel" :update="update" />
        </template>

        <!-- Generated Blueprints -->
        <template #tab-blueprints>
            <slot name="blueprints" :rows="blueprints" :loading="blueprintLoading" />
        </template>

    </BasePage>

</template>

<script setup>

import { ref } from "vue"
import { useRoute } from "vue-router"

const route = useRoute()

const props = defineProps({

    rows: Array,
    loading: Boolean,

    createModel: Object,

    discover: Function,
    update: Function

})

const activeTab = ref("sources")

const selected = ref(null)
const editModel = ref(null)

/*
Generated blueprints
*/

const blueprints = ref([])
const blueprintLoading = ref(false)

const header = route.meta.header

const tabs = [

    { key: "sources", label: "Discovered Sources" },
    { key: "discover", label: "Start Discovery" },
    { key: "inspect", label: "Schema Inspection" },
    { key: "blueprints", label: "Generated Blueprints" }

]

function selectRow(row) {

    selected.value = row
    editModel.value = { ...row }

    activeTab.value = "inspect"

}

</script>